import React from "react";
import { Navigate } from "react-router-dom";

const WithOutTokenRedirect = ({ children }) => {
  const userToken = localStorage.getItem("userToken");

  const token =
    userToken && userToken.trim() !== ""
      ? userToken
      : "";

      if (!token || token === "undefined" || token === "null" || token.trim() === "") {
        // 🚫 No token, redirect to home/login
    return <Navigate to="/" replace />;
  }

  // ✅ Token exists, allow access
  return <>{children}</>;
};

export default WithOutTokenRedirect;
